

<div class=" min-h-screen">

  <app-shared-layout [Analysis]="title"
                   [hideAdd]="false"
                   [viewDetails]="viewDetails"
                   [addPermission]="addPermission"
                   [smallForm]="viewType !== 'view'"
                   [secondaryWithStyle]="viewType !== 'view'"
                   [animationSize]="viewType !== 'view' ? 'eighty' : 'full'"
                   (addItem)="onAdd()"
                   [formTitle]="viewDetailsTitle"
                   (closeDetails)="closePanel()">

  <div ngProjectAs="primary-panel">
    
    <app-paginated-data-table
      
    [query]="query"
    [tableConfigurations]="tableConfiguration"
    [actionButtons]="actionButtons"
    [permissions]="permissions"
    (customAction)="customAction($event)"
    
    [upsertAction]="upsertAction"
    [deleteAction]="removeAction"
>
</app-paginated-data-table>
  </div>

  <div ngProjectAs="secondary-panel">
    <app-system-roles-view *ngIf="viewType === 'view'" (onClose)="closePanel()">
    </app-system-roles-view>
  </div>
</app-shared-layout>
</div>
